import BoxFilter from "./BoxFilter"

export default BoxFilter
